import api from "@/lib/api";

export default {
  urlGetAll: "/api/v1/human-resources/team/get-all",
  urlGetById: "/api/v1/human-resources/team/get-by-id",
  urlDelete: "/api/v1/human-resources/team/delete",
  urlCreate: "/api/v1/human-resources/team/create",
  urlUpdate: "/api/v1/human-resources/team/update",
  urlCreateBatch: "/api/v1/human-resources/team/create-batch",
  urlCalculateValue: "/api/v1/human-resources/team/calculate-value",

  getAll(cardId) {
    return api.get(this.urlGetAll, { params: { any: cardId } });
  },

  calculateValue(params) {
    return api.get(this.urlCalculateValue, { params });
  },

  getById(id) {
    return api.get(this.urlGetById, { params: { id } });
  },

  save(model) {
    const isNew = !model.id;
    return isNew ? api.post(this.urlCreate, model) : api.put(this.urlUpdate, model);
  },

  saveBatch(model) {
    return api.post(this.urlCreateBatch, model);
  },

  delete(id) {
    return api.delete(this.urlDelete, { params: { ids: id } });
  },
};
